import { ComponentProps, useMemo } from 'react';

import {
	getCloudinaryAssetUrlAutoFormat,
	isCloudinaryAsset,
} from '../../../../utils/cloudinary/getCloudinaryAssetUrlAutoFormat';

export type MarkdownImageProps = ComponentProps<'img'>;

export const MarkdownImage = ({ src, ...props }: MarkdownImageProps) => {
	const cloudinaryImageUrlAutoFormat = useMemo(
		() =>
			typeof src === 'string' &&
			src &&
			isCloudinaryAsset(src) &&
			getCloudinaryAssetUrlAutoFormat(src, 'image'),
		[src],
	);

	return (
		<img
			{...props}
			alt={props.alt}
			src={
				cloudinaryImageUrlAutoFormat && 'autoFormatImageSrc' in cloudinaryImageUrlAutoFormat
					? cloudinaryImageUrlAutoFormat.autoFormatImageSrc
					: src
			}
		/>
	);
};
